<template>
    <Dialog v-model:visible="visible" :dismissable-mask="true" @hide="onHide" modal
        :style="{ width: '500px' }">
        <LayoutModal>
            <div class="body">
                <div>
                    <error-image :alt="texts.title" />
                </div>
                <spacer vertical />
                <div>
                    <h1>{{ texts.title }}</h1>
                    <p>{{ texts.description }}</p>
                </div>
            </div>
            <template v-slot:footer>
                <split-row-all :one-line="true" reverse>
                    <text-button v-if="isHard" @click.prevent="reload">
                        {{ texts.restart }}
                    </text-button>

                    <text-button v-if="details" @mouseup="showDetails = !showDetails">
                        {{ texts.details }}
                    </text-button>
                </split-row-all>

                <div v-if="details && showDetails" class="details">
                    <div class="well">
                        <p v-for="(v, k) in details" :key="k">
                            <strong>{{ k }}:</strong><br>{{ v }}
                        </p>
                    </div>
                </div>
            </template>
        </LayoutModal>
    </Dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { onMounted } from "vue";
import LayoutModal from "@/components/layouts/LayoutModal";
import SplitRowAll from "@/components/elements/SplitRowAll";
import TextButton from "@/components/elements/TextButton";
import Spacer from "@/components/elements/Spacer";

export default {
    components: {
        LayoutModal,
        SplitRowAll,
        TextButton,
        Spacer
    },
    data() {
        return {
            visible: false,
            showDetails: false
        };
    },
    computed: {
        texts() {
            const base = this.$tm("modal_error");
            const overrides = this.error.type
                ? this.$tm("modal_error_" + this.error.type)
                : {} || {};
            return { ...base, ...overrides };
        },
        isHard() {
            return this.error && this.error.hard;
        },
        details() {
            return this.error && this.error.details ? this.error.details : null;
        },
        ...mapGetters({
            error: "error/getError"
        })
    },
    watch: {
        error: {
            handler(newValue) {
                if (newValue) {
                    this.showDialog();
                } else {
                    this.closeDialog();
                }
            },
            immediate: true
        }
    },
    methods: {
        showDialog() {
            this.visible = true;
        },
        closeDialog() {
            this.visible = false;
            this.$store.commit("error/clearError");
        },
        reload() {
            window.location.reload(true);
        },
        onHide() {
            this.$store.commit("error/clearError");
        }
    },
    expose: ['showDialog', 'closeDialog']
};
</script>

<style scoped>
.body {
    display: flex;
    justify-content: space-between;
}

.body img {
    display: block;
    margin: 0 auto;
}

.body h1 {
    font-size: 22px;
    margin-top: 0;
}

.body p {
    font-size: 14px;
}

.well {
    min-height: 20px;
    padding: 19px;
    margin-bottom: 20px;
    background-color: #f5f5f5;
    border: 1px solid #e3e3e3;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
}

.details {
    margin: 0;
    margin-top: 1rem;
}

.details > div {
    margin: 0;
    word-break: break-all;
}

@media all and (max-width: 819px) {
    .body {
        flex-direction: column;
    }

    .body h1,
    .body p {
        text-align: center;
    }
}
</style>
